import { create } from 'zustand';

const useContactPopupStore = create((set) => ({
  isOpen: false,
  openPopup: () => set({ isOpen: true }),
  closePopup: () => set({ isOpen: false })
}));

export const useContactPopup = () => {
  const { isOpen, openPopup, closePopup } = useContactPopupStore();
  return { isOpen, openPopup, closePopup };
};
